<template>
  <el-dialog
    :visible="visible"
    width="30%"
    top="30vh"
    :title="title"
    @close="handleClose"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item v-if="title === '编辑简历名称'" label="简历名称" prop="resume_name">
        <el-input clearable v-model="form.resume_name" placeholder="请输入简历名称" />
      </el-form-item>

      <el-form-item v-if="title === '编辑简历标签'" label="简历标签" prop="label">
        <div v-for="(item, index) in labelList" :key="index" class="label-item">
          <el-input clearable style="width: 70%;margin-right: 20px;" v-model.trim="labelList[index]" placeholder="请输入标签" />
          <el-button size="small" v-if="index === labelList.length - 1" type="primary" icon="el-icon-plus" circle @click="handleAddLabel"></el-button>
          <el-button size="small" v-if="index !== 0" type="danger" icon="el-icon-delete" circle @click="handleDeleteLabel(index)"></el-button>
        </div>
      </el-form-item>

      
      <el-form-item v-if="title === '编辑简历分类'" label="简历分类" prop="category_id">
        <el-select clearable style="width: 100%" v-model="form.category_id" placeholder="请选择分类">
          <el-option v-for="item in categoryOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取消</el-button>
      <el-button size="small" type="primary" @click="handleSave">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { addResumeBasicInfo } from '@/api/resume'

export default {
  name: 'ResumeHeaderDialog',
  props: {
    categoryOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      title: '',
      labelList: [],
      form: {
        id: null,
        resume_name: '',
        label: [],
        category_id: ''
      },
      rules: {
        resume_name: [{ required: true, message: '请输入简历名称', trigger: 'blur' }],
        label: [{ required: true, message: '请选择标签', trigger: 'change' }],
        category_id: [{ required: true, message: '请选择分类', trigger: 'change' }]
      }
    }
  },
  watch: {
    labelList: {
      handler(newVal) {
        this.form.label = newVal.filter(item => item !== '').join(',')
      },
      deep: true
    }
  },
  methods: {
    handleClose() {
      this.visible = false
      this.$refs.form.resetFields()
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {}
          const { resume_name, category_id, id } = this.form
          if (this.title === '编辑简历名称') {
            params.resume_name = resume_name
          } else if (this.title === '编辑简历分类') {
            params.category_id = category_id
          } else if (this.title === '编辑简历标签') {
            params.label = this.form.label
          }
          addResumeBasicInfo({ ...params, id }).then(res => {
            if (res.data.code === 1) {
              this.$message.success('保存成功')
              this.handleClose()
              this.$parent.getResumeList()
            }
          })
        }
      })
    },
    handleAddLabel() {
      this.labelList.push('')
    },
    handleDeleteLabel(index) {
      this.labelList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  display: flex;
}

::v-deep .el-dialog__title {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  font-weight: 600;
}

.label-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>